import { Dialog, DialogContent } from '@superfunnel/ui-core/v2/Dialog';

import Editor from '@/components/Editor/Editor';

interface NewGlobalSectionEditorModalProps {
  globalSectionId?: string;
  open?: boolean;
  onClose?: () => void;
}

export default function NewGlobalSectionEditorModal({
  globalSectionId,
  open,
  onClose,
}: NewGlobalSectionEditorModalProps = {}) {
  if (!open || !globalSectionId) return null;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="h-screen w-screen max-w-none rounded-none bg-gray-50 p-0">
        <Editor
          mode="globalSection"
          globalSectionId={globalSectionId}
          onClose={() => onClose?.()}
        />
      </DialogContent>
    </Dialog>
  );
}
